// extracted by mini-css-extract-plugin
export default {"paper":"style_paper__7rv3g"};